import React, { useEffect, useState } from 'react'
import Wrapper from '../../../../../../common/component/Wrapper'
import * as HMS from "../../../../../../common/component/Index";
import * as Func from '../../../../../../../../helpers/functions';
import { Input, Radio } from 'antd';
import { DATE_TIME_FORMAT, TRANSPORTATIN_OBJECT_TYPE, TRANSPORT_TYPE } from '../../../../../../../../constants/Define';
import AntSelect, { AntOption } from '../../../../../../common/component/AntSelect';
import moment from 'moment';
import { getVehicle, getVehicleTypes } from '../../../../../../../../services/orderService';

const Transportation = (props) => {

    const {
        item = {},
        validationTransportation = [],
        t,
        onChangeTransportation,
        onSelectObjectType,
        onChangeDateTransportation,
        airports = [],
        routes = [],
        vehicleTypesUpdated = null,
        vehiclesUpdated = null,
        index,
        isUpdated = false,
        propertyId
    } = props

    const [vehicleTypes, setVehicleTypes] = useState([])
    const [vehicles, setVehicles] = useState([])

    const initVehicleTypes = async (routeId) => {
        const vehicleTypes = await getVehicleTypes(routeId, propertyId)
        setVehicleTypes(vehicleTypes.data)
    }

    const initVehicle = async (vehicleTypeId) => {
        const vehicles = await getVehicle(vehicleTypeId, propertyId)
        setVehicles(vehicles.data)
    }

    return (
        <div className="row">
            <Wrapper className="col-md-6">
                <HMS.FormWrapperInputComponent
                    isRequired={true}
                    isValidation={true}
                    dataValidation={item.name}
                    validation={!!validationTransportation[index] && validationTransportation[index].name}
                    labelTitle={t(`item.infoRedeem.transportation.name`)}
                >   
                    <Input placeholder="" type={`text`}
                        disabled={isUpdated}
                        className={`form-control`}
                        name={'name'} 
                        onChange={(e) => onChangeTransportation('name', e.target.value, index)}
                        value={Func.checkUndefine(item.name)} 
                    />
                </HMS.FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6">
                {
                    !isUpdated &&
                    <HMS.FormWrapperInputComponent
                        isRequired={true}
                        isValidation={true}
                        dataValidation={item.object}
                        validation={!!validationTransportation[index] && validationTransportation[index].object}
                        labelTitle={t(`item.infoRedeem.transportation.object`)}
                    >   
                        <Wrapper>
                            <Radio.Group 
                                onChange={(e) => onSelectObjectType('object', e.target.value, index)} 
                                value={item.object}
                            >
                                {
                                    Object.keys(TRANSPORTATIN_OBJECT_TYPE).map(object => (
                                        <Radio 
                                            key={TRANSPORTATIN_OBJECT_TYPE[object].key} 
                                            value={TRANSPORTATIN_OBJECT_TYPE[object].value}
                                        >
                                            {t(`item.infoRedeem.transportation.${TRANSPORTATIN_OBJECT_TYPE[object].key}`)}
                                        </Radio>
                                    ))
                                }
                            </Radio.Group>
                        </Wrapper>
                    </HMS.FormWrapperInputComponent>
                }
            </Wrapper>
            
            <Wrapper className="col-md-12">
                <HMS.FormWrapperInputComponent
                    isRequired={true}
                    isValidation={true}
                    dataValidation={item.dateTimeValue}
                    validation={!!validationTransportation[index] && validationTransportation[index].dateTimeValue}
                    labelTitle={t(`item.infoRedeem.transportation.transportDateTime`)}
                >   
                    <HMS.DatePickerComponent
                        disabled={isUpdated}
                        disabledDate={(current) => current && current < moment().add(-1, 'day')}
                        onChange={data => onChangeDateTransportation('dateTimeValue', data.fullValue, index)}
                        showTime
                        name={'dateTimeValue'}
                        format={DATE_TIME_FORMAT.DATE_TIME}
                        value={item.dateTimeValue || ( isUpdated && (moment(item.transportDate + ' ' + item.transportTime)) ) || null}
                        placeholder=""
                        style={{ width: '100%' }}
                    />
                </HMS.FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6">
                <HMS.FormWrapperInputComponent
                    isRequired={true}
                    isValidation={true}
                    dataValidation={item.transportType}
                    validation={!!validationTransportation[index] && validationTransportation[index].transportType}
                    labelTitle={t(`item.infoRedeem.transportation.transportType`)}
                >  
                    <AntSelect className="select-group"
                        showArrow showSearch
                        disabled={isUpdated}
                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.infoRedeem.transportation.transportType")).toLowerCase())}
                        value={item.transportType}
                        onChange={id => onChangeTransportation('transportType', id, index)}
                        style={{ width: '100%' }}
                        // filterOption={selectFilterSearch}
                    >
                        {(TRANSPORT_TYPE || []).map((value, index) => (
                            <AntOption key={value} value={value}>
                                {t(`item.infoRedeem.transportation.listTransportype.${value}`)}
                            </AntOption>
                        ))}
                    </AntSelect>
                </HMS.FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6">
                <HMS.FormWrapperInputComponent
                    isRequired={true}
                    isValidation={true}
                    dataValidation={item.routeId}
                    validation={!!validationTransportation[index] && validationTransportation[index].routeId}
                    labelTitle={t(`item.infoRedeem.transportation.route`)}
                >   
                    <AntSelect className="select-group"
                        showArrow showSearch
                        disabled={isUpdated}
                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.infoRedeem.transportation.route")).toLowerCase())}
                        value={item.routeId || item.route?.id}
                        onChange={id => {
                            onChangeTransportation('routeId', id, index)
                            onChangeTransportation('vehicleTypeId', '', index)
                            onChangeTransportation('vehicleId', '', index)
                            initVehicleTypes(id, index)
                        }}
                        style={{ width: '100%' }}
                        // filterOption={selectFilterSearch}
                    >
                        {(routes || []).map((route, index) => (
                            <AntOption key={route.id} value={route.id}>
                                {route.name}
                            </AntOption>
                        ))}
                    </AntSelect>
                </HMS.FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6">
                <HMS.FormWrapperInputComponent
                    isRequired={true}
                    isValidation={true}
                    dataValidation={item.vehicleTypeId}
                    validation={!!validationTransportation[index] && validationTransportation[index].vehicleTypeId}
                    labelTitle={t(`item.infoRedeem.transportation.vehicleType`)}
                >   
                    <AntSelect className="select-group"
                        showArrow showSearch
                        disabled={isUpdated}
                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.infoRedeem.transportation.vehicleType")).toLowerCase())}
                        value={item.vehicleTypeId || item.vehicleType?.id}
                        onChange={id => {
                            onChangeTransportation('vehicleTypeId', id, index)
                            onChangeTransportation('vehicleId', '', index)
                            initVehicle(id, index)
                        }}
                        style={{ width: '100%' }}
                        // filterOption={selectFilterSearch}
                    >
                        {(vehicleTypesUpdated || vehicleTypes || []).map((vehicleType, index) => (
                            <AntOption key={vehicleType.id} value={vehicleType.id}>
                                {vehicleType.name}
                            </AntOption>
                        ))}
                    </AntSelect>
                </HMS.FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6">
                <HMS.FormWrapperInputComponent
                    isRequired={true}
                    isValidation={true}
                    dataValidation={item.vehicleId}
                    validation={!!validationTransportation[index] && validationTransportation[index].vehicleId}
                    labelTitle={t(`item.infoRedeem.transportation.vehicle`)}
                >   
                    <AntSelect className="select-group"
                        showArrow showSearch
                        disabled={isUpdated}
                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.infoRedeem.transportation.vehicle")).toLowerCase())}
                        value={item.vehicleId || item.vehicle?.id}
                        onChange={id => {
                            onChangeTransportation('vehicleId', id, index)
                        }}
                        style={{ width: '100%' }}
                        // filterOption={selectFilterSearch}
                    >
                        {(vehiclesUpdated || vehicles || []).map((vehicle, index) => (
                            <AntOption key={vehicle.id} value={vehicle.id}>
                                {vehicle.name}
                            </AntOption>
                        ))}
                    </AntSelect>
                </HMS.FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6">
                <HMS.FormWrapperInputComponent
                    labelTitle={t(`item.infoRedeem.transportation.flightNumber`)}
                >   
                    
                    <Input placeholder="" type={`text`}
                        className={`form-control`}
                        name={'flightNumber'} 
                        disabled={isUpdated}
                        onChange={(e) => onChangeTransportation('flightNumber', e.target.value, index)}
                        value={Func.checkUndefine(item.flightNumber)} 
                    />
                </HMS.FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6">
                <HMS.FormWrapperInputComponent
                    labelTitle={t(`item.infoRedeem.transportation.serialTicket`)}
                >   
                    
                    <Input placeholder="" type={`text`}
                        className={`form-control`}
                        name={'note'} 
                        disabled={isUpdated}
                        onChange={(e) => onChangeTransportation('note', e.target.value, index)}
                        value={Func.checkUndefine(item.note)} 
                    />
                </HMS.FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6">
                <HMS.FormWrapperInputComponent
                    labelTitle={t(`item.infoRedeem.transportation.departureLocation`)}
                >   
                    <AntSelect className="select-group"
                        showArrow showSearch
                        disabled={isUpdated}
                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.infoRedeem.transportation.departureLocation")).toLowerCase())}
                        value={item.departureLocation}
                        onChange={id => onChangeTransportation('departureLocation', id, index)}
                        style={{ width: '100%' }}
                        // filterOption={selectFilterSearch}
                    >
                        {(airports || []).map((airport, index) => (
                            <AntOption key={airport.id} value={airport.id}>
                                {airport.name} ({airport.id})
                            </AntOption>
                        ))}
                    </AntSelect>
                </HMS.FormWrapperInputComponent>
            </Wrapper>
            <Wrapper className="col-md-6">
                <HMS.FormWrapperInputComponent
                    labelTitle={t(`item.infoRedeem.transportation.arrivalLocation`)}
                >   
                    <AntSelect className="select-group"
                        showArrow showSearch
                        disabled={isUpdated}
                        placeholder={Func.capitalizeFirstLetter((t('placeHolderForm.select') + " " + t("item.infoRedeem.transportation.arrivalLocation")).toLowerCase())}
                        value={item.arrivalLocation}
                        onChange={id => onChangeTransportation('arrivalLocation', id, index)}
                        style={{ width: '100%' }}
                        // filterOption={selectFilterSearch}
                    >
                        {(airports || []).map((airport, index) => (
                            <AntOption key={airport.id} value={airport.id}>
                                {airport.name} ({airport.id})
                            </AntOption>
                        ))}
                    </AntSelect>
                </HMS.FormWrapperInputComponent>
            </Wrapper>
        </div>
    )
}

export default Transportation